"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageOptions = exports.getCloudinaryCdnHostName = exports.getCloudinaryApiUrl = exports.CROP = void 0;
var _each = _interopRequireDefault(require("lodash/each"));
var _constants = require("../constants");
var _hostUtils = require("./host-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var imageOptionsMap = {
  width: 'w',
  height: 'h',
  pixelRatio: 'dpr',
  crop: 'c'
};
var CROP = exports.CROP = {
  FIT: 'fit',
  LIMIT: 'limit'
};
var getCloudinaryCdnHostName = exports.getCloudinaryCdnHostName = function getCloudinaryCdnHostName() {
  return (0, _hostUtils.localiseHostName)(_constants.CLOUDINARY_CDN_HOSTNAME);
};
var getCloudinaryApiUrl = exports.getCloudinaryApiUrl = function getCloudinaryApiUrl() {
  return (0, _hostUtils.localiseHostName)(_constants.CLOUDINARY_URL);
};
var getImageOptions = exports.getImageOptions = function getImageOptions(overrideOptions) {
  if (!overrideOptions) {
    return [];
  }
  var options = _objectSpread({
    pixelRatio: 'auto',
    crop: CROP.FIT
  }, overrideOptions);
  var optionsArray = [];
  (0, _each["default"])(options, function (option, key) {
    optionsArray.push("".concat(imageOptionsMap[key], "_").concat(option));
  });
  return optionsArray;
};
//# sourceMappingURL=cloudinary-utils.js.map